import React from 'react'
import LegalPage from '../components/LegalPage'

const PrivacyPolicy: React.FC = () => (
  <LegalPage
    document="privacyPolicy"
    sections={[
      'introduction',
      { key: 'informationWeCollect', subsections: ['personalInfo', 'usageInfo'] },
      'howWeUse',
      'mobileApps',
      'messages',
      'dataSecurity',
      'dataSharing',
      'yourRights',
      'contact',
    ]}
  />
)

export default PrivacyPolicy
